import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c9557a58")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"max-width":"1200px","width":"90%","margin":"16px auto","padding":"0 16px"} }
const _hoisted_3 = { style: {"margin":"8px"} }
const _hoisted_4 = { style: {"font-size":"24px","color":"#fff"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Add liquidity")
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"16px"}
}
const _hoisted_7 = { class: "tag" }
const _hoisted_8 = {
  class: "tag",
  style: {"margin-left":"8px"}
}
const _hoisted_9 = { class: "block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "titleInBlock" }, "Volume 24H", -1)
const _hoisted_11 = { class: "contentInBlock" }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "titleInBlock" }, "TVL", -1)
const _hoisted_14 = { class: "contentInBlock" }
const _hoisted_15 = { class: "block" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "titleInBlock" }, "APY 7D", -1)
const _hoisted_17 = { class: "contentInBlock" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" CHART ")
_popScopeId()

import { computed, inject, ref, watch, onMounted, Ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Obyte from "@/obyte";
import Pool from "@/helpers/PoolHelper";
import fetchCandlesForLast30Days from "@/api/fetchCandlesForLast30Days";
import { ICandles } from "@/interfaces/candles.inerface";
import Menu from "@/components/Menu.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const Client = inject("Obyte") as Obyte.Client;
const store = useStore();
const route = useRoute();

store.dispatch("initIfNotInit", Client);
const isReady = computed(() => store.state.ready);
const poolsData = computed(() => store.state.poolsData);
const tickers = computed(() => store.state.tickers);
const pool: Ref<Pool> = ref({} as Pool);
const candles: Ref<ICandles[]> = ref([]);

async function updatePool() {
  if (!isReady.value) return;
  pool.value = poolsData.value.pools.find((p: Pool) => {
    return p.address === route.params.address;
  });

  const { assets } = poolsData.value;
  candles.value = await fetchCandlesForLast30Days(
    pool.value.getTickerForAPI(assets)
  );
}

function goToOswapIO(): void {
  const a = document.createElement("a");
  a.href = "https://oswap.io/#/add-liquidity/" + pool.value.address;
  a.target = "_blank";
  a.click();
}

watch(poolsData, updatePool);
watch(
  () => route.params.market_name,
  () => {
    if (route.params.market_name) {
      updatePool();
    }
  }
);
onMounted(updatePool);

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Menu),
    (_unref(isReady) && pool.value.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(pool.value.ticker), 1),
                _createVNode(_component_a_tag, { class: "tag fee" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(pool.value.swapFee / 1000000000) + "%", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  style: {"border-radius":"8px","float":"right","margin-top":"2px"},
                  onClick: goToOswapIO
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              (pool.value.hasLiquidity())
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, " 1 " + _toDisplayString(pool.value.getTicker(pool.value.asset0, _unref(poolsData).assets)) + " ≈ " + _toDisplayString(pool.value.getFormattedPrice(
                pool.value.asset0,
                pool.value.asset1_decimals,
                _unref(poolsData).assets
              )) + " " + _toDisplayString(pool.value.getSymbol(pool.value.asset1, _unref(poolsData).assets)), 1),
                    _createElementVNode("span", _hoisted_8, " 1 " + _toDisplayString(pool.value.getTicker(pool.value.asset1, _unref(poolsData).assets)) + " ≈ " + _toDisplayString(pool.value.getFormattedPrice(
                pool.value.asset1,
                pool.value.asset0_decimals,
                _unref(poolsData).assets
              )) + " " + _toDisplayString(pool.value.getSymbol(pool.value.asset0, _unref(poolsData).assets)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_a_row, { style: {"color":"#fff","margin-top":"24px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  sm: 24,
                  md: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, " $" + _toDisplayString(pool.value.get24hVolumeInUSD(
                  _unref(tickers),
                  _unref(poolsData).assets,
                  _unref(Client).exchangeRates
                )), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, "$" + _toDisplayString(pool.value.marketcap.toFixed(2)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, _toDisplayString(pool.value.getAPY7d(candles.value, _unref(Client).exchangeRates)) + "% ", 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  sm: 24,
                  md: 18,
                  style: {"padding":"16px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})